module.exports = __webpack_public_path__ + "img/mine_active.b2c216ba.png";